import { Card } from 'antd';
import { createUseStyles } from 'react-jss';

export type ModuleCardProps = {
  title?: string;
  topRightContent?: React.ReactNode;
  children: React.ReactNode;
  block?: boolean;
};

const useStyles = createUseStyles({
  moduleCard: {
    border: 'none',
    boxShadow: '0px 5px rgba(120, 120, 120, 0.1)',
    borderRadius: 16,
    '& .ant-card-body': {
      padding: '12px 16px 20px',
    },
  },
  moduleCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  cardTitle: {
    margin: 0,
    color: '#595959',
  },
});

const ModuleCard: React.FC<ModuleCardProps> = ({ title, topRightContent, children, block = true }) => {
  const styles = useStyles();

  return (
    <Card className={styles.moduleCard} style={{ width: block ? '100%' : 'fit-content' }}>
      <div className={styles.moduleCardHeader}>
        {title && <h2 className={styles.cardTitle}>{title}</h2>}
        {topRightContent}
      </div>
      {children}
    </Card>
  );
};
export default ModuleCard;
